import { useImperativeHandle } from 'react';
import { useEditorEventCallback } from '@handlewithcare/react-prosemirror';
import { RichEditorRef } from '../types';

export function RichEditorRefProvider({
  editorRef,
}: {
  editorRef: React.RefObject<RichEditorRef | null>;
}) {
  const addMention = useEditorEventCallback((view, mentionId: string, mentionText: string) => {
    const tr = view.state.tr
      .delete(0, view.state.doc.content.size)
      .insert(
        1,
        view.state.schema.nodes.mention.create(
          { modelId: mentionId },
          view.state.schema.text(mentionText)
        )
      )
      .insertText(' ');
    view.dispatch(tr);
    view.focus();
  });

  const clear = useEditorEventCallback((view) => {
    const tr = view.state.tr.delete(0, view.state.doc.content.size);
    view.dispatch(tr);
    view.focus();
  });

  useImperativeHandle(editorRef, () => ({
    addMention,
    clear,
  }));

  return null;
}
